import Profile from './Profile.container'
export default Profile
